import axios from "axios";

import * as actionTypes from "./actionTypes";

export const initSendServiecAsDraft = () => {
  return {
    type: actionTypes.INIT_SEND_SERVICE_AS_DRAFT,
    postingService: true,
  };
};

export const successSendServiecAsDraft = (data, serviceId) => {
  return {
    type: actionTypes.SUCCESS_SEND_SERVICE_AS_DRAFT,
    postingService: false,
    draftService: data,
    draftServiceId: serviceId,
  };
};

export const failSendServiecAsDraft = (error) => {
  return {
    type: actionTypes.FAIL_SEND_SERVICE_AS_DRAFT,
    postingService: false,
    darfServiceError: error,
  };
};

export const sendServiceAsDraft = (serviceType, data, mediaData) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("idToken"),
    },
  };
  const configMedia = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("idToken"),
      "Content-Type": "multipart/form-data",
    },
  };
  // const mediaLen = mediaData.media.length;
  // let uploadedImgCounter = 0;
  return (dispatch) => {
    dispatch(initSendServiecAsDraft());
    axios.post(`${serviceType}/lists`, data, config).then((response) => {
      const serviceId = response.data.data.id;
      localStorage.setItem("draftId", serviceId);
      let formData = new FormData();
      mediaData.media.forEach((img, i) => {
        formData.append(`media[${i}][name]`, img.name);
        formData.append(`media[${i}][content]`, img.content);
        if (img.name === "video") {
          formData.append(`media[${i}][type]`, "mp4");
        }
      });
      axios
        .post(`${serviceType}/lists/${serviceId}`, formData, configMedia)
        .then((res) => {
          // uploadedImgCounter++;
          dispatch(successSendServiecAsDraft(response.data, serviceId));
          // if (uploadedImgCounter === mediaLen) {
          //     // dispatch(getPreviewPost(postId));
          // }
        });
    });
  };
};
